import React, { useState, useEffect } from "react";
import axios from "axios";
import { apiUrl } from "../../constants";

const PublisherIcon = ({ logoId, index, handleClick, border }) => {
  const [icon, setIcon] = useState(null);

  // When we have the ids for the publisher icons we get the base64 version of the images belonging to the current creative and return them.
  useEffect(() => {
    async function getPublisherLogo() {
      const jwtToken = localStorage.getItem("token");
      try {
        const { data } = await axios.get(
          `${apiUrl}/formsettings/publishersicon/${logoId}`,
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          }
        );
        let fileType = "";
        if (data.charAt(0) === "/") {
          fileType = "jpeg";
        }
        if (data.charAt(0) === "i") {
          fileType = "png";
        }

        const image = `data:image/${fileType};base64,${data}`;

        setIcon(image);
      } catch (e) {
        console.error(e);
      }
    }
    if (logoId !== undefined) {
      getPublisherLogo();
    }
  }, [logoId]);

  return (
    <>
      {icon && (
        <img
          className={`device-website-icon logo${index} ${border}`}
          src={icon}
          key={index}
          alt={"device"}
          onClick={handleClick}
        />
      )}
    </>
  );
};

export default PublisherIcon;
